"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROD_DECESION_MAKER_FORM_ATTRIBUTES = exports.QA_DECESION_MAKER_FORM_ATTRIBUTES = exports.QA_PQL_FORM_ATTRIBUTES = exports.PRODUCTION_PQL_FORM_ATTRIBUTES = void 0;

var _createFormAttributes = function _createFormAttributes(formId, portalId) {
  return {
    formId: formId,
    portalId: portalId
  };
};

var PRODUCTION_PQL_FORM_ATTRIBUTES = _createFormAttributes('5ae29a72-cc99-4702-9bcc-936891469830', '53');

exports.PRODUCTION_PQL_FORM_ATTRIBUTES = PRODUCTION_PQL_FORM_ATTRIBUTES;

var QA_PQL_FORM_ATTRIBUTES = _createFormAttributes('479b8d6d-b9b2-4941-b16a-74d2cef76778', '99609805');

exports.QA_PQL_FORM_ATTRIBUTES = QA_PQL_FORM_ATTRIBUTES;

var QA_DECESION_MAKER_FORM_ATTRIBUTES = _createFormAttributes('4505c281-fbc0-4e82-afe1-363bfbe364ea', '18770');

exports.QA_DECESION_MAKER_FORM_ATTRIBUTES = QA_DECESION_MAKER_FORM_ATTRIBUTES;

var PROD_DECESION_MAKER_FORM_ATTRIBUTES = _createFormAttributes('352aafba-a522-41de-ad81-8053b66e5156', '53');

exports.PROD_DECESION_MAKER_FORM_ATTRIBUTES = PROD_DECESION_MAKER_FORM_ATTRIBUTES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/pql/formAttributes.js
// module id = 614
// module chunks = 5 6